/**
 * Openingstijden drag&drop toevoegen (?)
 */

jQuery(document).ready(function($) {
    planningBoardSetup();

    if (is_dev) {
        $('.add-button').click();
    }
});

function planningBoardSetup() {
    const $ = jQuery.noConflict();

    if ($('.planning-board-wrapper').length > 0) {
        initPlanningBoard();
    }
    if ($('.planning-board-data-input').length > 0) {
        initPlanningBoardDataInput();
    }
}

function initPlanningBoard() {
    const $ = jQuery.noConflict();
    // Set some default params
    //
    let boardAjax = 0;

    // Get the settings
    let settings = getBoardSettings();

    // Get the wrapper
    //
    const gridWrapper = $('.planning-board-grid-wrapper');

    //Set the type in the grid
    //
    gridWrapper.addClass('type-' + settings.type);
    gridWrapper.parent().addClass('type-' + settings.type);

    // Set the travelBreak div and remove it from the grid
    //
    const travelBreakElm = $('.travel-break').clone(true,true);
    $('.travel-break').remove();

    //Set the date the grid has to load
    //
    $('input[name="currentGridDate"]').change(function() {
        const date = new Date();
        const p = $(this).val().split('-');
        date.setDate(parseInt(p[0]));
        date.setMonth(parseInt(p[1]) - 1);
        date.setFullYear(parseInt(p[2]));
        settings.date = date.getTime();
        reloadGrid();
    });
    // Set the date to today
    //
    $('[data-board-today]').click(function() {
        const date = new Date();
        $('input[name="currentGridDate"]').val(date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()).trigger('change');
        return false;
    });
    $('[data-board-previous], [data-board-next]').click(function() {
        const direction = $(this).is('[data-board-next') ? 'forward' : 'backwards';
        const move_days = settings.type === 'd' ? 1 : 7;
        const date = new Date();
        date.setTime(settings.date);
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000) * (direction === 'forward' ? 1 : -1 ) * move_days);
        $('input[name="currentGridDate"]').val(date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()).trigger('change');
        return false;
    });





    // Add spacing for open time or not
    //
    gridWrapper.bind('reloadMerge', function() {
        mergeGrid(settings.merged);
    });
    $('input#merged-switch').change(function() {
        settings.merged = $(this).is(':checked');
        setCookie(getSettingsCookieName(), settings);
        gridWrapper.trigger('reloadMerge');
    }).prop('checked', settings.merged);

    // Change the board type based on the selector
    //
    $('[data-board-type-button]').click(function() {
        gridWrapper.removeClass('type-' + settings.type);
        gridWrapper.parent().removeClass('type-' + settings.type);
        $('[data-board-type-button]').removeClass('active');
        $(this).addClass('active');
        settings.type = $(this).attr('data-board-type-button');
        gridWrapper.addClass('type-' + settings.type);
        gridWrapper.parent().addClass('type-' + settings.type);
        setCookie(getSettingsCookieName(), settings);
        reloadGrid();
        return false;
    });
    $('[data-board-type-button]:not([data-board-type-button="' + settings.type + '"])').removeClass('active');
    $('[data-board-type-button="' + settings.type + '"]').addClass('active');

    // Hide or show empty columns
    //
    $('input#empty-switch').change(function() {
        settings.showEmpty = $(this).is(':checked');
        setCookie(getSettingsCookieName(), settings);
        toggleEmptyBoxes();

    }).prop('checked', settings.showEmpty);

    // Horizontal or vertical days
    //
    $('input#direction-switch').change(function() {
        settings.direction = $(this).is(':checked') ? 'vertical' : 'horizontal';
        setCookie(getSettingsCookieName(), settings);
        toggleDirection();
    });

    // Hide or show other employees' columns
    $('input#people-switch').change(function() {
        settings.group = $(this).is(':checked');
        setCookie(getSettingsCookieName(), settings);
        toggleGroup();
    }).prop('checked', settings.group);

    gridWrapper.bind('reload', function() {
        settings = getBoardSettings();
        reloadGrid();
    }).trigger('reload');

    function mergeGrid(merged) {
        // Show space between inspections to show empty space
        if (merged === false) {
            let first_time = null;
            let last_time = null;
            let shortest_duration = null;
            let smallest_size = null;
            $('.task-list-wrapper').each(function() {
                $('.form-wrapper.set').each(function() {
                    const data = $(this).getThisElementsData();

                    const start = new Date();
                    if (data.start_time === undefined) {
                        data.start_time = data.start_datetime.split(' ')[1];
                    }
                    start.setHours(parseInt(data.start_time.split(':')[0]), data.start_time.split(':')[1]);

                    const end = new Date();
                    if (data.end_time=== undefined) {
                        data.end_time = data.end_datetime.split(' ')[1];
                    }
                    end.setHours(parseInt(data.end_time.split(':')[0]), data.end_time.split(':')[1]);

                    if (first_time === null || first_time > start) {
                        first_time = start;
                    }
                    if (last_time === null || last_time < end) {
                        last_time = end;
                    }

                    const minute_diff = Math.floor((Math.abs(end - start)/1000)/60);
                    if (shortest_duration === null || minute_diff < shortest_duration) {
                        shortest_duration = minute_diff;
                        smallest_size = parseFloat($(this).outerHeight()) + 25;
                    }
                });
            });

            if (first_time !== null && last_time !== null && shortest_duration !== null && smallest_size !== null) {
                $('.form-wrapper.set').each(function() {
                    const data = $(this).getThisElementsData();
                    const start = new Date();
                    start.setHours(parseInt(data.start_time.split(':')[0]), data.start_time.split(':')[1]);
                    const end = new Date();
                    end.setHours(parseInt(data.end_time.split(':')[0]), data.end_time.split(':')[1]);
                    const minute_diff = Math.floor((Math.abs(end - start)/1000)/60);

                    if (minute_diff !== shortest_duration) {
                        // Set the height accordingly to the smallest size
                        const h = smallest_size / shortest_duration * minute_diff;
                        $(this).height(h - 25);
                    }

                    if ($(this).nextAll('.form-wrapper.set').length > 0) {
                        const nextAppointment = $(this).nextAll('.form-wrapper.set:first');
                        const next_data = nextAppointment.getThisElementsData();
                        const next_start = new Date();
                        next_start.setHours(parseInt(next_data.start_time.split(':')[0]), next_data.start_time.split(':')[1]);
                        const minute_diff = Math.floor((Math.abs(next_start - end)/1000)/60);
                        const h = smallest_size / shortest_duration * minute_diff;
                        nextAppointment.prevAll('.dropzone:first').height(h + 25);
                    }

                    if (start > first_time && $(this).prevAll('.form-wrapper.set').length === 0) {
                        // Increase the height of the previous dropzone
                        //
                        const minute_diff = Math.floor((Math.abs(start - first_time)/1000)/60);
                        const h = smallest_size / shortest_duration * minute_diff;
                        $(this).prevAll('.dropzone:first').height(h + 25);
                    }
                    if (end < last_time && $(this).nextAll('.form-wrapper.set').length === 0) {
                        // Increase the height of the next dropzone
                        const minute_diff = Math.floor((Math.abs(last_time - end)/1000)/60);
                        const h = smallest_size / shortest_duration * minute_diff;
                        $(this).nextAll('.dropzone:first').height(h + 25);
                    }
                });
            }
        } else {
            $('.form-wrapper.set').removeAttr('style');
            $('.dropzone').removeAttr('style');
        }
    }
    function toggleEmptyBoxes() {
        // Show or hide the empty boxes
        const show = settings.showEmpty;
        gridWrapper.toggleClass('hide-empty', show === false);
        if (show === true) {
            if (gridWrapper.is('[data-original-columns]')) {
                gridWrapper.css('grid-template-columns', gridWrapper.attr('data-original-columns'));
            }
        } else {
            let columns = gridWrapper.attr('data-original-columns');
            if (columns === undefined) {
                columns = gridWrapper.css('grid-template-columns');
                gridWrapper.attr('data-original-columns', columns);
            }
            columns = columns.split(' ');
            $('.planning-board-grid').each(function() {
                const grid = $(this);
                const index = grid.parent().index();
                if (grid.hasClass('empty')) {
                    columns[index] = (parseFloat(columns[index]) / parseInt(grid.attr('data-contains'))) + 'px';
                } else {
                    // Check if it contains empty lists
                    if (grid.children('.empty').length > 0) {
                        columns[index] = (parseFloat(columns[index]) / parseInt(grid.attr('data-contains')) * parseInt(grid.attr('data-contains-filled'))) + 'px';
                    }
                }
            });
            gridWrapper.css('grid-template-columns', columns.join(' '));
        }
    }
    function toggleDirection() {
        const direction = settings.direction;
        gridWrapper.removeClass('direction-' + (direction === 'horizontal' ? 'vertical' : 'horizontal'));
        gridWrapper.addClass('direction-'  + direction);
    }
    function toggleGroup() {
        const group = settings.group;
        const user = get_current_user();
        const employeeId = user.employee.id;
        gridWrapper.find('.board-list-wrapper:not([data-id="' + employeeId + '"])').toggle(group);
    }
    function toggleWeek(from, to) {
        const type = settings.type;
        if (type === 'w') {
            let days_count = 0;
            for(let i = parseInt(gridWrapper.attr('data-week_from')); i <= parseInt(gridWrapper.attr('data-week_to')); i++) {
                let container = gridWrapper.children('.planning-board-grid-container:first');
                if (days_count === 0) {
                    container.attr('data-day', i);
                } else {
                    container = gridWrapper.children('.planning-board-grid-container[data-day="' + i + '"]');

                    if (container.length === 0) {
                        const clone = gridWrapper.children('.planning-board-grid-container:first').clone(true,true);
                        clone.attr('data-day', i);
                        gridWrapper.append(clone);
                        container = gridWrapper.find('[data-day="' + i + '"]');
                    }
                }

                const this_from = new Date(from);
                this_from.setTime(this_from.getTime() + (i - 1) * 24 * 60 * 60 * 1000);
                const this_to = new Date(this_from);
                this_to.setHours(23,59,59);

                container.find('.planning-board-grid').attr('data-from', this_from.getTime());
                container.find('.planning-board-grid').attr('data-to', this_to.getTime());


                const date_str = leadingZero(this_from.getDate()) + '-' + leadingZero(this_from.getMonth() + 1) + '-' + this_from.getFullYear();
                container.find('.container-title sub').html(date_str);


                const full_date_str = 'Week ' + this_from.getWeek() +  ', ' + this_from.getFullYear();
                $('.board-heading-2').html(full_date_str);

                days_count++;
            }
            gridWrapper.attr('data-days-count', days_count);
        } else {
            gridWrapper.children('.planning-board-grid-container:not(:first)').remove();
            gridWrapper.children('.planning-board-grid-container:first').find('.planning-board-grid').attr('data-from', from.getTime());
            gridWrapper.children('.planning-board-grid-container:first').find('.planning-board-grid').attr('data-to', to.getTime());
            gridWrapper.children('.planning-board-grid-container:first').attr('data-day', to.getDay());


            const month_names = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
            const currentDate = new Date();
            currentDate.setTime(settings.date);
            const date_str = leadingZero(currentDate.getDate()) + '-' + leadingZero(currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
            gridWrapper.children('.planning-board-grid-container:first').find('.container-title sub').html(date_str);
            const full_date_str = leadingZero(currentDate.getDate()) + ' ' + month_names[(currentDate.getMonth() )] + ' ' + currentDate.getFullYear();
            $('.board-heading-2').html(full_date_str);
        }
    }
    function getGridData() {
        $('body').isLoading();

        const url = gridWrapper.attr('data-url');
        if (url === undefined) {
            return;
        }




        if (!gridWrapper[0].defaultFormWrapperHtml) {
            gridWrapper[0].defaultFormWrapperHtml = gridWrapper.find('.form-wrapper').html();
        }

        const from = new Date(settings.date);
        from.setHours(0,0,0);
        const to = new Date(settings.date);
        to.setHours(23,59,59);

        if (settings.type === 'w') {
            from.setTime(from.getTime() - (from.getDay() - 1) * 24 * 60 * 60 * 1000);
            to.setTime(from.getTime() + 6 * 24 * 60 * 60 * 1000);
            to.setHours(23,59,59);
        }

        // Create weekdays if needed
        toggleWeek(from, to);

        const filters = settings.filters;
        filters['from'] = from.getTime() / 1000;
        filters['to'] = to.getTime() / 1000;




        if (boardAjax !== 0) {
            boardAjax.abort();
        }
        boardAjax = $.ajax({
            url: url,
            data: filters,
            error: function(e, str) {
                if (str !== 'abort') {
                    squde_flash('Er is iets fout gegaan. Vernieuw de pagina of neem contact met ons op.', 'error');
                    $('body').doneLoading();
                }
            },
            success: function(data) {
                $('body').doneLoading();
                gridWrapper.attr('data-entity-count', data.length);

                gridWrapper.children('.planning-board-grid-container').each(function() {
                    const grid = $(this).find('.planning-board-grid');

                    const container_from = new Date();
                    container_from.setTime(grid.attr('data-from'));
                    const container_to = new Date();
                    container_to.setTime(grid.attr('data-to'));

                    let added = 0;

                    grid.attr('data-contains', data.length);
                    grid.children().removeClass('set');
                    grid.children(':not(:nth-child(1))').remove();
                    data.forEach(function(obj, i) {


                        let listWrapper = grid.children(':nth-child(' + (i + 1) + ')');
                        if (listWrapper.length === 0) {
                            grid.children(':first').clone(true,true).appendTo(grid);
                            listWrapper = grid.children(':nth-child(' + (i + 1) + '):first');
                            listWrapper.find('li.dropzone').remove();
                        }
                        listWrapper.addClass('set');
                        listWrapper.attr('data-id', obj.id);
                        listWrapper.find('.board-list-title').html(obj.title);



                        listWrapper.find('li').removeClass('set');

                        listWrapper.find('.form-wrapper').each(function(index) {
                            $(this).attr('data-index', (index + 1));
                        });

                        let rowIndex = 0;
                        obj.data.forEach(function(row) {

                            // First check if it fits in the container
                            //
                            const from = new Date();

                            // Create start datetime if not exists
                            //
                            if (!row.start_datetime) {
                                row.start_datetime = row.date + ' ' + row.start_time;
                            }
                            if (!row.end_datetime) {
                                row.end_datetime = row.date + ' ' + row.end_time;
                            }

                            row.start_time = row.start_datetime.split(' ')[1];
                            from.setHours(row.start_time.split(':')[0], row.start_time.split(':')[1], row.start_time.split(':')[2]);
                            from.setFullYear(row.start_datetime.split('-')[0], (parseInt(row.start_datetime.split('-')[1]) - 1), row.start_datetime.split('-')[2].split(' ')[0]);

                            if (from.getDate() + '' + from.getMonth() + '' + from.getFullYear() === container_from.getDate() + '' + container_from.getMonth() + '' + container_from.getFullYear()) {


                                let li = listWrapper.find('li[data-index=' + (rowIndex + 1) + ']');
                                if (li.length === 0) {
                                    listWrapper.find('.form-wrapper:first').clone(true, true).attr('data-index',(rowIndex + 1) ).appendTo(listWrapper.find('ul'));
                                    li = listWrapper.find('li[data-index=' + (rowIndex + 1) + ']:first');
                                }
                                li.addClass('set');

                                li.setAppointment(row);
                                rowIndex++;
                                added++;
                            }
                        });
                        listWrapper.toggleEmptyWrapper();
                    });
                    grid.attr('data-contains-filled', grid.find('.board-list-wrapper.set:not(.empty)').length);
                    grid.toggleClass('empty', added === 0);
                });
                putNewItemsOnScreen();
                mergeGrid(settings.merged);
                toggleEmptyBoxes();
                toggleDirection();
                toggleGroup();
            }
        })
    }

    function reloadGrid() {
        setCookie(getSettingsCookieName(), settings);
        getGridData();
    }

    function putNewItemsOnScreen() {
        // if (is_dev) {
        //     gridWrapper[0]['new_appointments'] = JSON.parse('[{"customer":{"id":45,"parent_company_id":null,"invoice_relation_id":null,"client_id":"166","invoice_address_id":58,"name":"Aannemingsbedrijf Lagecaexa","coc_no":"","tax_no":"","phone":"0522-465944","invoice_email":null,"notes":null,"enabled":1,"created_at":"2018-12-13 21:53:11","updated_at":"2018-12-13 22:21:43","address":{"id":58,"name":"Factuuradres","postal_code":"7951 LL","city":"Staphorst","street":"Westerparallelweg","street_no":24,"street_no_adding":null,"country_code":"","created_at":"2018-12-13 21:53:11","updated_at":"2018-12-13 21:53:11","pivot":{"company_id":45,"address_id":58}},"these_contacts":[319,1174]},"order":{"id":88,"uid":9,"client_id":166,"contact_id":null,"employee_id":null,"company_id":45,"user_id":1,"plannable":1,"reference":null,"invoice_id":null,"contract_id":null,"parent_order_id":null,"order_date":"2019-12-05 00:00:00","header_text":null,"footer_text":null,"contact_company_name":"Aannemingsbedrijf Lagecaexa","contact_name":null,"department":null,"address":"Westerparallelweg 24","postal_code":"7951 LL","city":"Staphorst","country_code":"NL","lat":0,"lng":0,"company_name":"Visual Systems","company_address":"De Reest 60","company_postal_code":"8253 PW","company_city":"Dronten","company_phone":"0321 31 77 99","company_country_code":"NL","company_coc_no":"39060615","company_tax_no":"NL286890192B01","company_iban":"NL01 INGB 0001 123 456","print_layout_id":6,"created_at":"2019-12-05 15:11:33","updated_at":"2019-12-05 15:11:33","client":{"id":45,"parent_company_id":null,"invoice_relation_id":null,"client_id":"166","invoice_address_id":58,"name":"Aannemingsbedrijf Lagecaexa","coc_no":"","tax_no":"","phone":"0522-465944","invoice_email":null,"notes":null,"enabled":1,"created_at":"2018-12-13 21:53:11","updated_at":"2018-12-13 22:21:43","address":{"id":58,"name":"Factuuradres","postal_code":"7951 LL","city":"Staphorst","street":"Westerparallelweg","street_no":24,"street_no_adding":null,"country_code":"","created_at":"2018-12-13 21:53:11","updated_at":"2018-12-13 21:53:11","pivot":{"company_id":45,"address_id":58}},"these_contacts":[319,1174]},"actionsList":[],"deviceCount":0,"hasOtherActions":false,"printOptions":[{"title":"Standaard Werkbon","action":"print_regular_layout(\'/print/12/88\')"}],"touched":false,"viewAction":"view_order(88);","mapsRouteUrl":"https://www.google.com/maps/dir//Westerparallelweg+24,7951+LL,Staphorst/"},"order_id":88,"date":"2019-12-6","start_time":"08:00","end_time":"09:00","duration":"1u","uid":"98yf6","employee_id":"1"}]');
        // }

        if (gridWrapper[0]['new_appointments']) {
            const date = new Date(settings.date);
            const dateStr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            const data = gridWrapper[0]['new_appointments'].filter((appointment) => {
                return appointment.date === dateStr;
            });
            data.forEach((appointment) => {
                const listWrapper = gridWrapper.find('.board-list-wrapper[data-id="' + appointment.employee_id + '"]');
                const dropzone = listWrapper.find('li.dropzone:first');
                dropzone.removeClass('dropzone').droppable('disable').removeClass('ui-droppable');
                const apptElm = dropzone.setAppointment(appointment);
                apptElm.addClass('set');
                apptElm.parents('.board-list-wrapper').toggleClass('empty', apptElm.parents('.board-list-wrapper').find('ul li[data-data-str]').length === 0);
                if (appointment.tr_id) {
                    apptElm[0].tr = $('.inspection-orders-list').find('tr[data-id="' + appointment.tr_id + '"]');
                }
            });
        }
    }
}

function initPlanningBoardDataInput() {
    const $ = jQuery.noConflict();
    const dataInput = $('.planning-board-data-input');
    const toggleDataInput = function(open) {
        //Toggles the data input screen
        //
        if (open === undefined) {
            $('body').toggleClass('data-input-open');
        } else if (open === true && !$('body').hasClass('data-input-open')) {
            $('body').addClass('data-input-open');
        } else if (open === false && $('body').hasClass('data-input-open')) {
            $('body').removeClass('data-input-open');
        }

        if ($('body').hasClass('data-input-open')) {
            $('[data-employee-selector]').employeeSelector();
            $('[data-reloadable-url]').reloadThisElement();
            $('[data-reloadable-url]').unbind('onReload').bind('onReload', function() {

                const table = $(this);
                resizeContentUntilFits(table, table.parents('.planning-board-data-input'));
                table.find('tbody tr').customDraggable({
                    refreshPositions: true,
                    delay: 2000,
                    helper: function(event, ui) {
                        const data = $(this).getThisElementsData();

                        return $('body').setAppointment({
                            customer: data.client,
                            order: data
                        })
                            .offset({
                                // top: event.pageY
                            })
                            .css({
                                width: $('.grid-col:first').outerWidth(true),
                                zIndex: 3000,
                            })
                            .attr('data-correction-left', event.pageX)
                            .addClass('floating-appointment-wrapper');
                    },
                    drag: function(event, ui) {
                        ui.position.left += (ui.helper.outerWidth() * -1) * 0.5 + parseInt(ui.helper.attr('data-correction-left'));
                        // ui.position.top += 10;
                    },
                    start: function (event, ui) {

                        ui.helper.css({
                        });
                    }, stop: function () {
                    }
                });
            });
        }
    };
    dataInput.find('.close-reveal-modal').click(function() {
        toggleDataInput(false);
        return false;
    });
    $('.add-button').click(function() {
        toggleDataInput();
        return false;
    });
}
function getBoardSettings() {
    // Set the default settings
    //
    const defaultSettings = {
        type: 'd',
        date: new Date().getTime(),
        merged: true,
        showEmpty: true,
        direction: 'horizontal',
        group: jQuery('input#people-switch').length === 0,
        filters: {}
    };
    // Get settings from a cookie
    //
    const cookieSettings = getCookie(getSettingsCookieName(), defaultSettings);

    // Add non-existing keys to the settings if needed
    //
    Object.keys(defaultSettings).forEach(function(defaultSettingKey) {
        if (cookieSettings[defaultSettingKey] === undefined) {
            cookieSettings[defaultSettingKey] = defaultSettings[defaultSettingKey];
        }
    });

    // Cast a date from the settings
    //
    cookieSettings.date = new Date().setTime(cookieSettings.date);

    return cookieSettings;
}
function getBoardFilters() {
    return getBoardSettings()['filters'];
}

function setBoardFilters(filters) {
    const settings = getBoardSettings();
    settings.filters = filters;
    setCookie(getSettingsCookieName(), settings);

    jQuery('.planning-board-grid-wrapper').trigger('reload');
}
function getSettingsCookieName() {
    return 'boardSettings-' + jQuery('.planning-board-grid-wrapper').attr('data-type');
}


(function ( jQuery ) {
    jQuery.fn.setAppointment = function(data, callback) {
        const settings = getCookie(getSettingsCookieName());
        const $ = jQuery.noConflict();
        let elm = this;

        if (typeof data === 'string') {
            data = JSON.parse(data);
        }

        if (data.start_datetime !== undefined && data.start_time === undefined) {
            data['start_time'] = data.start_datetime.split(' ')[1];
        }
        if (data.end_datetime !== undefined && data.end_time === undefined) {
            data['end_time'] = data.end_datetime.split(' ')[1];
        }

        let startTime;
        if (data.start_time) {
            data['start_time'] = data['start_time'].split(':');
            data['start_time'] = data['start_time'][0] + ':' + data['start_time'][1];

            startTime = new Date();
            startTime.setHours(data.start_time.split(':')[0]);
            startTime.setMinutes(data.start_time.split(':')[1]);
        }

        let endTime;
        if (data.end_time) {
            data['end_time'] = data['end_time'].split(':');
            data['end_time'] = data['end_time'][0] + ':' + data['end_time'][1];

            endTime = new Date();
            endTime.setHours(data.end_time.split(':')[0]);
            endTime.setMinutes(data.end_time.split(':')[1]);
        }

        if (startTime && endTime) {
            data.duration = (Math.round((Math.abs(startTime - endTime) / 36e5) * 10) / 10) + 'u';
        }


        const id = get_unique_id();

        if (data.uid === undefined) data.uid = id;

        if (data.id === undefined && elm.parents('.planning-board-wrapper').length > 0) {
            let setAppointments = elm.parents('.planning-board-grid-wrapper')[0]['new_appointments'];
            if (!setAppointments) {
                setAppointments = [];
            }
            if (setAppointments.filter((appointment) => {
                return appointment.uid === data.uid;
            }).length === 0) {
                data.employee_id = elm.parents('.board-list-wrapper').attr('data-id');
                if (elm[0].tr) {
                    data.tr_id = elm[0].tr.attr('data-id')
                }
                setAppointments.push(data);
                elm.parents('.planning-board-grid-wrapper')[0]['new_appointments'] = setAppointments;
            }

        }

        let appointmentElm = elm;
        if (elm.parents('ul').length === 0) {
            elm.append('<div class="appointment-wrapper"' +
                'id="' + id + '"></div>');
            appointmentElm = $('#' + id);

            // appointmentElm.replaceWith($('.planning-board-grid').find('li:not(.travel-break):not(.dropzone):not(.ui-droppable-disabled):first').clone(true,true));
            appointmentElm.html($('.planning-board-grid').find('li:not(.travel-break):not(.dropzone):not(.ui-droppable-disabled):first').html());
        } else {
            let h = 25;

            if (appointmentElm.html().length === 0) {
                h = $(this).height() - 25;
                let clone = null;

                if ($('body')[0]['boardFormWrapper']) {
                    clone = $('body')[0]['boardFormWrapper'].clone(true,true);
                } else {
                    $('.planning-board-grid').find('li.form-wrapper:not(.ui-droppable-disabled):first').each(function() {
                        if (!$(this).hasClass('ui-draggable') && clone === null) {
                            clone = $(this).clone(true,true);
                            $('body')[0]['boardFormWrapper'] = clone.clone(true,true);
                        }
                    });
                }
                clone.attr('id', id);
                const tr = appointmentElm[0]['tr'];
                appointmentElm.replaceWith(clone);
                appointmentElm = $('#' + id);

                appointmentElm.find('ul').find('li:not(:nth-child(1))').remove();
                appointmentElm[0]['tr'] = tr;
                elm = appointmentElm;
                h = h - elm.outerHeight(true);
                if (h < 25) {
                    h = 25;
                }
            }

            elm.setThisElementsData(data);

            const ref = get_unique_id();
            if (elm.prev().length === 0 || !elm.prev().hasClass('dropzone')) {
                elm.before('<li class="dropzone"></li>');
            }
            if (elm.next().length === 0 || !elm.next().hasClass('dropzone')) {
                const dropzone = $('<li class="dropzone"></li>');
                if (settings.merged === false) {
                    dropzone.height(h);
                }
                elm.after(dropzone);
            }
            elm.prev().attr('data-ref', ref);
            elm.next().attr('data-ref', ref);

            elm.parents('ul').find('.dropzone[data-ref="' + ref + '"]').setDropzone();
        }

        if (data.id === undefined) {
            appointmentElm.addClass('open');
            appointmentElm.find('[disabled]').removeAttr('disabled');

            if (appointmentElm.parents('ul').length > 0) {
                appointmentElm.find('input[data-list-id]').attr('value', appointmentElm.parents('.board-list-wrapper:first').attr('data-id'));
            }
        } else {
            appointmentElm.removeClass('open');
            appointmentElm.find(':input').attr('disabled', 'disabled');
        }

        // Set the color
        //
        if (data.css) {
            if(data.css !== undefined) {
                if(data.css['background-color']) {
                    appointmentElm.find('.yellow-bar').css('background-color', data.css['background-color']);
                }
            }
        }

        // Edit the form names
        //
        if (data.id === undefined && appointmentElm.parents('form').length > 0) {
            appointmentElm.find(':input[name]').each(function() {
                $(this).removeAttr('disabled');

                let name = $(this).attr('name');

                if ($(this).is('[data-original-name]')) {
                    name = $(this).attr('data-original-name');
                } else {
                    $(this).attr('data-original-name', name);
                }
                name = 'boardData[' + data.uid + '][' + name + ']';


                $(this).attr('name', name);
            });
        }

        // Close it if clicked
        //
        appointmentElm.find('.close-button').removeAttr('style').unbind('click').click(function() {
            const data = appointmentElm.getThisElementsData();
            if (data.id) {
                cancelVisit(data);
            } else {
                cancelVisitPlan();
            }
        });

        if (data.id) {
            if (data.done || (data.order && data.order.touched)) {
                appointmentElm.find('.close-button').unbind('click').css({'opacity': 0.3});
            }
        }

        // Open if clicked
        //
        appointmentElm.find('.open-button a').unbind('click').click(function() {
            const gridWrapper = appointmentElm.parents('.planning-board-grid-wrapper');
            data = $(this).parents('.form-wrapper').getThisElementsData();
            let dataKey = 'id';
            if (gridWrapper.is('[data-detail-fn-key]')) {
                dataKey = gridWrapper.attr('data-detail-fn-key');
            }
            console.log({data, val: data[dataKey], dataKey});
            if (data[dataKey] && gridWrapper.is('[data-detail-fn]')) {
                eval(gridWrapper.attr('data-detail-fn') + '(' + data[dataKey] + ');');
            }
            return false;
        });

        // Set the ID and show or hide the close button
        //
        if (data.id !== undefined) {
            appointmentElm[0].dbId = data.id;
            appointmentElm.attr('data-id', data.id);
        } else {
            appointmentElm.removeAttr('data-id');
        }

        // Open links if there are
        //
        appointmentElm.find('a[data-open-fn]:not([data-open-fn=""])').unbind('click').click(function() {
            const args = $(this).attr('data-args').split(',');
            const setArgs = [];
            args.forEach(function(arg) {
                let val = null;
                try {
                    val = eval('data.' + arg);
                } catch(e) {

                }
                setArgs.push(val);
            });

            const fn = $(this).attr('data-open-fn');

            eval(fn + '(' + setArgs.map(function(value, index) {return 'setArgs['+ index + ']'}).join(',') + ')');
            return false;
        });
        appointmentElm.find('a[data-opens]:not([data-opens=""])').each(function() {
            const opens = $(this).attr('data-opens');
            const value = eval('data.' + opens);

            $(this).attr('href', value);

            return false;
        });



        // console.log({data});
        // Fill the fields with their designated keys
        //
        appointmentElm.find('[id]').each(function() {
            if (!$(this).is('[data-list-id]')) {
                const key = $(this).attr('id');
                try {
                    let val = eval('data.' + key);

                    if (typeof val === 'object' && ((val[0] && typeof val[0] !== 'object') || Object.keys(val).length === 0)) {
                        val = val.join(', ');
                    }

                    if (typeof val !== 'object') {
                        if ($(this).is(':input')) {
                            $(this).val(val).attr('data-before-value', val);
                        } else {
                            if ($(this).parent().is('a[data-open-fn=""]')) {
                                $(this).html(val);
                                $(this).parent().replaceWith($(this));
                            } else {
                                $(this).html(val);
                            }
                        }
                    }
                } catch (e) {
                    // Skip it
                    //
                }
            }
        });

        // Fill the links with their designated keys
        //
        appointmentElm.find('a[data-href]').each(function() {
            const a = $(this);
            const key = a.attr('data-href');
            try {
                const val = eval('data.' + key);
                if (typeof val != 'object') {
                    a.attr('href', val);
                }
            } catch (e) {
                // Skip it
                //
            }
        });

        // If its open, its also draggable still
        if (appointmentElm.hasClass('open')) {
            appointmentElm.draggable({
                refreshPositions: true,
                helper: function(event, ui) {
                    const data = $(this).getThisElementsData();

                    return $('body').setAppointment(data)
                        .offset({
                            // top: event.pageY
                        })
                        .css({
                            width: $('.grid-col:first').outerWidth(true),
                            zIndex: 3000,
                        })
                        .attr('data-correction-left', event.pageX)
                        .addClass('floating-appointment-wrapper');
                },
                start: function (event, ui) {
                    jQuery(event.target).addClass('is-being-dragged');
                }, stop: function (event, ui) {
                    jQuery(event.target).removeClass('is-being-dragged');
                }
            });
        }


        appointmentElm.find('input#start_time, input#end_time').unbind('change').change(function() {
            const id = $(this).attr('id');
            const v = $(this).val();
            data[id] = v;

            if (id === 'start_time') {
                const before = $(this).attr('data-before-value');
                const before_start = new Date();
                before_start.setHours(before.split(':')[0], before.split(':')[1]);

                const start = new Date();
                start.setHours(v.split(':')[0], v.split(':')[1]);

                const end_v = $(this).parents('.form-wrapper').find(':input#end_time').val();
                let end = new Date();
                end.setHours(end_v.split(':')[0], end_v.split(':')[1]);

                if (start >= end) {
                    const diff = end - before_start;
                    end = new Date(start);
                    end.setMilliseconds(start.getMilliseconds() + diff);

                    let m = end.getMinutes();
                    m = m < 10 ? '0' + m : m;
                    let h = end.getHours();
                    h = h < 10 ? '0' + h : h;
                    data['end_time'] = h + ':' + m;
                }
            }

            if (id === 'end_time') {
                const before = $(this).attr('data-before-value');
                const before_end = new Date();
                before_end.setHours(before.split(':')[0], before.split(':')[1]);

                const end = new Date();
                end.setHours(v.split(':')[0], v.split(':')[1]);

                const start_v = $(this).parents('.form-wrapper').find(':input#start_time').val();
                let start = new Date();
                start.setHours(start_v.split(':')[0], start_v.split(':')[1]);

                if (end <= start) {
                    const diff = before_end - start;
                    start = new Date(end);
                    start.setMilliseconds(start.getMilliseconds() - diff);

                    let m = start.getMinutes();
                    m = m < 10 ? '0' + m : m;
                    let h = start.getHours();
                    h = h < 10 ? '0' + h : h;
                    data['start_time'] = h + ':' + m;
                }
            }

            setTimeout(function() {
                if($('.timepicker-wrapper').length === 0) {
                    // Check if the start and end fit
                    // If there is one before, start cant be before the other one ends
                    const prev = appointmentElm.prevAll('.form-wrapper:first:visible');
                    const next = appointmentElm.nextAll('.form-wrapper:first:visible');
                    const start = new Date();
                    start.setHours(data['start_time'].split(':')[0], data['start_time'].split(':')[1]);
                    const end = new Date();
                    end.setHours(data['end_time'].split(':')[0], data['end_time'].split(':')[1]);

                    let reset = false;
                    if (prev.length > 0) {
                        const prevData = prev.getThisElementsData();
                        const prevEnd = new Date();
                        prevEnd.setHours(prevData['end_time'].split(':')[0], prevData['end_time'].split(':')[1]);

                        if (start < prevEnd) {
                            squde_flash('Kan geen andere planning overlappen.', 'alert');
                            reset = true;
                        }
                    }
                    if (reset === false && next.length > 0) {
                        const nextData = next.getThisElementsData();
                        const nextStart = new Date();
                        nextStart.setHours(nextData['start_time'].split(':')[0], nextData['start_time'].split(':')[1]);

                        if (start > nextStart || end > nextStart) {
                            squde_flash('Kan geen andere planning overlappen.', 'alert');
                            reset = true;
                        }
                    }

                    if (reset === true) {
                        data = appointmentElm.getThisElementsData();
                    }

                    appointmentElm.setAppointment(data, callback);
                }
            }, 1000);
        });

        checkForNewAppointments();

        reload_timepickers();

        if (appointmentElm.parents('ul').length > 0) {
            appointmentElm.parents('.board-list-wrapper').toggleEmptyWrapper();
        }


        // After the appointment has been set, update all of the following appointments
        // But only if there are no id's in these appointments
        const nextAppointment = appointmentElm.nextAll('.form-wrapper.set:first');
        let numberOfIds = 0;
        appointmentElm.nextAll('.form-wrapper.set').each(function() {
            const data = $(this).getThisElementsData();
            if (data.id) {
                numberOfIds++;
            }
        });
        if (nextAppointment.length > 0 && endTime && numberOfIds === 0) {
            // If the next appointment is in they wave, scootch!
            const nextData = nextAppointment.getThisElementsData();
            let nextStart = new Date();
            nextStart.setHours(parseInt(nextData.start_time.split(':')[0]), nextData.start_time.split(':')[1], 0, 0);
            // console.log({endTime: endTime.getHours(), nextStart: nextStart.getHours()});
            if (endTime > nextStart) {
                let nextEnd = new Date();
                nextEnd.setHours(parseInt(nextData.end_time.split(':')[0]), nextData.end_time.split(':')[1], 0, 0);
                const diff = nextEnd - nextStart;
                nextStart = new Date(endTime);
                nextStart.setMilliseconds(nextStart.getMilliseconds() + diff);
                nextEnd = new Date(nextStart);
                nextEnd.setMilliseconds(nextStart.getMilliseconds() + diff);
                nextData.start_time = leadingZero(nextStart.getHours(), 2) + ':' + leadingZero(nextStart.getMinutes(), 2);
                nextData.end_time = leadingZero(nextEnd.getHours(), 2) + ':' + leadingZero(nextEnd.getMinutes(), 2);
                nextAppointment.setAppointment(nextData, callback);
            }
        }

        appointmentElm.bind('cancelVisit', function() {
            appointmentElm = $(this);
            if (appointmentElm.prev().prev().length > 0) {
                appointmentElm.prev('.dropzone').remove();
            } else if (appointmentElm.next().next().length === 0) {
                appointmentElm.next('.dropzone').remove();
            }
            appointmentElm.parents('.board-list-wrapper').toggleEmptyWrapper();
            if (appointmentElm[0]['tr']) {
                appointmentElm[0]['tr'].show();
            }


            const gridWrapper = appointmentElm.parents('.planning-board-grid-wrapper');
            const boardListWrapper = appointmentElm.parents('.board-list-wrapper');
            appointmentElm.remove();

            checkForNewAppointments();

            boardListWrapper.toggleClass('empty', boardListWrapper.find('ul li[data-data-str]').length === 0);
            gridWrapper.trigger('reloadMerge');
        });

        return appointmentElm;

        function cancelVisitPlan() {
            const gridWrapper = appointmentElm.parents('.planning-board-grid-wrapper');
            if (gridWrapper[0]['new_appointments']) {
                const data = appointmentElm.getThisElementsData();
                gridWrapper[0]['new_appointments'] = gridWrapper[0]['new_appointments'].filter((appointment) => {
                    return appointment.uid !== data.uid;
                });
            }

            appointmentElm.trigger('cancelVisit');
        }
        function cancelVisit(visit) {
            cancel_visit(visit.id, function() {
                const gridWrapper = $('.planning-board-grid-wrapper');
                appointmentElm.trigger('cancelVisit');
                gridWrapper.trigger('reload');
            })
        }


        function checkForNewAppointments() {
            if (elm.prop('tagName') === 'BODY') {
                return;
            }
            let found_new = false;

            appointmentElm.parent().children('li.open').each(function() {
                if ($(this)[0]['dbId'] === undefined) {
                    found_new = true;
                }
            });
            if (found_new === true) {
                $('.screen-button-wrapper.save-button-wrapper').removeClass('hidden');
            } else {
                $('.screen-button-wrapper.save-button-wrapper').addClass('hidden');
            }
        }
    };

}( jQuery ));
(function ( jQuery ) {
    jQuery.fn.setDropzone = function() {
        const onDrop = function(event, ui) {
            const dropzone = jQuery(event.target);
            const gridWrapper = dropzone.parents('.planning-board-grid-wrapper');
            let appt;
            let original_appt = null;
            if (ui.draggable.prop('tagName') === 'TR') {
                const order = ui.draggable.getThisElementsData();
                appt = {
                    customer: order.client,
                    order: order,
                    order_id: order.id
                };
            } else {
                appt = ui.draggable.getThisElementsData();
                original_appt = ui.draggable.getThisElementsData();
            }

            const date = new Date();

            // Get the date this was dropped on
            //
            const timestamp = dropzone.parents('.planning-board-grid').attr('data-from');
            date.setTime(timestamp);


            // Check if there is an appointment before this dropzone
            //
            const start_time = new Date();
            try {
                const prevData = dropzone.prev().getThisElementsData();
                const prevTime = prevData.end_time;
                start_time.setHours(parseInt(prevTime.split(':')[0]));
                start_time.setMinutes(parseInt(prevTime.split(':')[1]));
            } catch (e) {
                start_time.setHours(8);
                start_time.setMinutes(0);
            }
            start_time.setMilliseconds(0);



            // Duration can come from the contract in the future
            //
            const duration = 60;
            const end_time = new Date(start_time);
            end_time.setMinutes(end_time.getMinutes() + duration);

            // Save the date (PUN intended)
            //
            appt.date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            appt.start_time = leadingZero(start_time.getHours(), 2) + ':' + leadingZero(start_time.getMinutes(), 2);
            appt.end_time = leadingZero(end_time.getHours(), 2) + ':' + leadingZero(end_time.getMinutes(), 2);

            // Set the employee to where it was dropped
            //
            const employee_id = dropzone.parents('.board-list-wrapper:first').attr('data-id');
            appt.employee_id = parseInt(employee_id);


            if (employee_id === undefined || JSON.stringify(appt) === JSON.stringify(original_appt)) {
                return;
            }

            const actuallyDropIt = function(appt) {
                dropzone.removeClass('dropzone').droppable('disable').removeClass('ui-droppable');
                if (ui.draggable.prop('tagName') === 'TR') {
                    dropzone[0]['tr'] = ui.draggable;
                    ui.draggable.hide();
                } else {
                    dropzone[0]['tr'] = ui.draggable[0].tr;
                    ui.draggable.remove();
                    ui.draggable.next('.dropzone:first').remove();
                }
                const apptElm = dropzone.setAppointment(appt);

                apptElm.addClass('set').removeClass('ui-droppable-disabled');

                apptElm.parents('.board-list-wrapper').toggleClass('empty', apptElm.parents('.board-list-wrapper').find('ul li[data-data-str]').length === 0);
            };

            // Check if there is an appointment after this dropzone, and if you can't scootch it
            // alert this
            //
            let prevented = false;
            try {
                let numberOfIds = 0;
                dropzone.nextAll('.form-wrapper.set').each(function() {
                    const data = jQuery(this).getThisElementsData();
                    if (data.id) {
                        numberOfIds++;
                    }
                });

                if (numberOfIds > 0) {
                    const next_data = dropzone.next().getThisElementsData();
                    const next_start = new Date();
                    next_start.setHours(parseInt(next_data.start_time.split(':')[0]), next_data.start_time.split(':')[1]);
                    const minute_diff = Math.floor((Math.abs(next_start - start_time) / 1000) / 60);
                    if (minute_diff < duration) {
                        prevented = true;
                        if (minute_diff === 0) {
                            foundationPopup('<div class="text-center"><p>Dit gaat helaas niet passen.</p><button class="button primary">Sluiten</button></div>', function(elm, popup) {
                                elm.find('button').click(function() {
                                    popup.close();
                                });
                            }, 'tiny');
                        } else {
                            const div = jQuery('<div class="text-center"></div>');
                            const new_duration = duration - minute_diff;
                            div.prepend('<p>Wilt u de planning verkorten van ' + duration + ' minuten naar ' + new_duration + ' minuten om deze passend te krijgen?</p>');
                            const cancel = jQuery('<button class="button secondary">Annuleren</button>');
                            const ok = jQuery('<button class="button primary">Prima</button>');
                            div.append(cancel).append(' ').append(ok);
                            foundationPopup(div, function(elm, popup) {
                                cancel.click(function() {
                                    popup.close();
                                });
                                ok.click(function() {
                                    // Recalculate end time with new duration
                                    //
                                    const end_time = new Date(start_time);
                                    end_time.setMinutes(end_time.getMinutes() + new_duration);

                                    // Save the date again (PUN intended)
                                    //
                                    appt.end_time = leadingZero(end_time.getHours(), 2) + ':' + leadingZero(end_time.getMinutes(), 2);
                                    actuallyDropIt(appt);

                                    // Since your duration could be the smalles one, and you may have merged-grid:off
                                    // Re-render the grid
                                    gridWrapper.trigger('reloadMerge');

                                    popup.close();
                                })
                            }, 'tiny');
                        }
                    }
                }

            } catch (e) {

            }

            if (prevented === false) {
                actuallyDropIt(appt);
            }
        };


        jQuery(this).droppable({
            tolerance: 'pointer',
            drop: onDrop
        }).on('drop', onDrop);
    };
}( jQuery ));
(function ( jQuery ) {
    jQuery.fn.toggleEmptyWrapper = function() {
        const listWrapper = jQuery(this);
        listWrapper.toggleClass('empty', listWrapper.find('.set').length === 0);
        if (listWrapper.hasClass('empty')) {
            listWrapper.find('ul').prepend('<li class="dropzone"></li>');
            listWrapper.find('.dropzone').setDropzone();
        }
    };
}( jQuery ));

(function ( jQuery ) {
    jQuery.fn.resetBoard = function() {
        const $ = jQuery.noConflict();
        const board = jQuery(this);
        board.find('.form-wrapper:not([data-id])').remove();
        const defaultHtml = board[0].defaultFormWrapperHtml;
        board.find('.task-list-wrapper ul').each(function() {
            if ($(this).find('.form-wrapper').length === 0) {
                $(this).append('<li class="form-wrapper" data-index="1">' + defaultHtml + '</li>');
            }
        });
        if (board[0].new_appointments) {
            board[0].new_appointments = [];
        }
    };
}( jQuery ));
